/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
import { Window } from '../../../00_IMMEDIATE/Window';
import { FriendshipChest_Card, FRIENDSHIPCHESTCARD_STATUS } from './FriendshipChest_Card';
/**
 * Another window for Friendship chest that gives the First Time User who was invited by a friend
 * a reward for reaching their goal of X levels!
 * @author Sandra Koo
 */
export class Window_friendshipChestFTUAward extends Window {
    constructor() {
        super();

        this.onFinishedEnter.addOnce(() => { this.enterFinished(); }); // onFinishEnter is called in Window base... somehow I made it in time!?


        if (game.state.current === 'World') {
            this.y = -G.WindowMgr.Constants.WorldVerticalOffset;
        }

        this.displayContainer = new Phaser.Group(G.game, this);
        this.card = undefined;
        this.claimElements = undefined;
        this.enterDone = false;

        this.drawElements();
    }

    async drawElements() {
        this.card = new FriendshipChest_Card(G.Game, this.displayContainer, 0);

        // Fill card with dummy info and a different prize table
        this.card.fillCard({ i: 0, s: FRIENDSHIPCHESTCARD_STATUS.FTUX, pi: 0 }, G.json.settings.friendshipChest_prizes.invitedTable);

        await this.readyClaim(this.card, (goods) => { this.drawComplete(goods); });
    }

    /**
     * Slightly similar to the same one in Friendship_Chest.js but has a spot for the friend
     */
    async readyClaim(card, onComplete) { // eslint-disable-line consistent-return
        const container = new Phaser.Group(G.game, null);
        const { prize } = card;

        const center = this.displayContainer.toLocal({ x: 0, y: card.positionals.chest }, card.fill).y;
        const shine = G.makeImage(0, center, 'shine_godrays', 0.5, container);
        shine.scale.set(1.5, 1.5);
        shine.update = () => {
            if (container.visible && shine.alpha > 0) {
                shine.angle += 0.25;
            }
        };
        shine.alpha = 0;

        const titleBanner = new Phaser.Group(G.game, container);
        const purple = G.makeImage(0, 0, 'purple_banner', 0.5, titleBanner);
        const purpleBannerText = new G.Text(0, 0, G.txt('Friendship Chest'), 'font-white', 0.5, purple.width * 0.95, purple.height, true, 'center');
        titleBanner.addChild(purpleBannerText);
        titleBanner.y = this.displayContainer.toLocal({ x: 0, y: card.positionals.friendshipChestTitle }, card.fill).y;

        const prizeSection = card.generatePrizeSection(prize, { style: 'font-white', fontSize: 64 });
        prizeSection.y = container.toLocal(card.positionals.prizeSection, card.positionals.prizeSection.parent).y;
        container.addChild(prizeSection);

        const chestOpen = G.makeImage(0, center, 'friendship_chest_full', 0.5, container);
        chestOpen.alpha = 0;
        chestOpen.scale.set(1.5, 1.5);

        const chestClosed = new Phaser.Group(G.game, container);
        G.makeImage(0, 0, 'friendship_chest_closed', 0.5, chestClosed);
        // G.makeImage(0, -35, 'chest_closed_lid', 0.5, chestClosed);
        chestClosed.y = center;

        const applyGifts = () => {
            const trackerArray = [];
            OMT.transactionTracking.logInventoryTransactionBegin();

            for (let i = 0; i < prize.length; i++) {
                const curPrize = prize[i];
                trackerArray.push([curPrize.prize, curPrize.amount]); // Puts into an array for data tracking

                switch (curPrize.prize) {
                    case 'coin':
                        this.state.uiTargetParticles.createCoinBatch( // Show bling
                            game.world.bounds.x + prizeSection.worldPosition.x,
                            prizeSection.worldPosition.y,
                            this.state.panel.coinsTxt,
                            curPrize.amount,
                            false,
                        );
                        OMT.transactionTracking.addInventoryChange('coins', 0, curPrize.amount);
                        break;
                    case 'life':
                        G.saveState.addLife(curPrize.amount); // Add life
                        break;
                    default:
                        { // Perhaps bad, but default is assuming booster
                            const boosterIndex = parseInt(curPrize.prize[8], 10);
                            G.saveState.changeBoosterAmount(boosterIndex, curPrize.amount, true); // Add in booster
                            OMT.transactionTracking.addInventoryChange('boostersReceived', boosterIndex, curPrize.amount);
                            break;
                        }
                }
            }

            DDNA.transactionHelper.trackRewards(trackerArray, [], { // DDNA tracking
                transactionType: 'REWARD',
                tActionType: 'FRIENDSHIPCHEST_JOINED',
                tGameArea: game.state.getCurrentState().key === 'Game' ? 'LEVEL' : 'MAP',
            });
            OMT.transactionTracking.logInventoryTransactionEnd();
            G.saveState.friendshipChestDataManager.triggerPromoInitial(); // Save!
            // G.saveState.save(); // Save!
        };

        const targetFriend = G.saveState.friendshipChestDataManager.getInvitedData();
        console.log("friendshipchestftue");
        const friends = await OMT.friends.getFriendsList(); // Might need to not use cache since new friends
        const friendData = friends.filter((fr) => fr.id === targetFriend)[0];
        const avatarSize = 88;
        const avatar = new Phaser.Group(G.game, null);
        let avatarImage;
        if (!friendData || (friendData && (!friendData.image || friendData.image === ''))) { // If theres no friend data, some how. Or the image is not there, or blank
            avatarImage = G.makeImage(0, 0, 'avatar_e', 0.5, avatar);
            avatarImage.width = avatarImage.height = 88;
        } else {
            avatarImage = G.makeExtImage(0, 0, friendData.image, 'avatar_e', 0.5, avatar, null, function resizeAvatar() {
                this.width = this.height = 88;
            });
        }
        avatarImage.width = avatarImage.height = avatarSize;
        const avatarFrame = G.makeImage(0, 0, 'avatar_frame', 0.5, avatar);
        avatarFrame.width = avatarFrame.height = avatarImage.height * 1.15;
        const bubblePack = new Phaser.Group(G.game, container);
        const bubble = G.makeImage(0, 0, 'thanks_bubble', 0.5, bubblePack);
        bubble.scale.set(1.5, 1.5);
        const bubbleText = new G.Text(0, 0, G.txt('Thanks for joining the game!'), 'font-white', 0.5, bubble.width * 0.8, bubble.height * 0.6, true, 'center');
        bubbleText.y = -bubbleText.height / 4;
        bubblePack.addChild(bubbleText);
        bubblePack.y = prizeSection.y + prizeSection.height / 2 + bubblePack.height * 0.6;
        avatar.y = bubblePack.y + (bubblePack.height + avatar.height) / 2;
        container.addChild(bubblePack);
        container.addChild(avatar);

        const returnedGoods = {
            container,
            prizeData: prize,
            banner: titleBanner,
            shine,
            chestOpen,
            chestClosed,
            prizeDisplay: prizeSection,
            applyGifts,
            friend: {
                bubble: bubblePack,
                avatar,
            },
        };

        if (onComplete) { onComplete(returnedGoods); } else { return returnedGoods; }
    }

    /**
     * When the window finishes entering
     */
    enterFinished() {
        this.enterDone = true;
        this.tryToAnimate();
    }

    /**
     * When the Claim objects are ready
     * @param {Object} goods
     */
    drawComplete(goods) {
        this.claimElements = goods;
        this.tryToAnimate();
    }

    /**
     * Waits for the claim elements to be done and the window has finished entering
     */
    tryToAnimate() {
        if (!this.claimElements || !this.enterDone) {
            return;
        }
        this.animateSequence();
    }

    /**
     * Waits and animate Claim!
     */
    animateSequence() {
        game.time.events.add(2000, () => {
            this.animateClaim(this.card, this.claimElements);
        }, this);
    }

    /**
     * Lots of tweens for animating the claim. Most of it is similar to Friendship_Chest.js
     * @param {FriendshipChest_Card} card
     * @param {Object} claimDisplay
     */
    animateClaim(card, claimDisplay) {
        const tweenTime = 500;

        const cardOut = game.add.tween(card) // tweening out the card
            .to({ alpha: 0 }, tweenTime, Phaser.Easing.Sinusoidal.InOut);

        // Applying and saving positions
        this.displayContainer.addChild(claimDisplay.container);
        claimDisplay.banner.scale.set(1.5, 0.5);
        claimDisplay.banner.alpha = 0;
        const chestY = claimDisplay.chestClosed.y;
        claimDisplay.prizeDisplay.alpha = 0;
        const prizeY = claimDisplay.prizeDisplay.y;
        claimDisplay.prizeDisplay.y = chestY;
        claimDisplay.chestClosed.scale.set(0.3, 0.3);
        claimDisplay.chestClosed.y = chestY - 20;
        claimDisplay.shine.alpha = 0;
        const friendY = claimDisplay.friend.avatar.y;
        claimDisplay.friend.avatar.y = chestY;
        claimDisplay.friend.avatar.alpha = 0;
        const bubbleY = claimDisplay.friend.bubble.y;
        claimDisplay.friend.bubble.y = friendY;
        claimDisplay.friend.bubble.alpha = 0;


        // Is this too much tweening...?
        const prizeIn = game.add.tween(claimDisplay.container) // The claim container tweens in (with whatever is visible)
            .to({ alpha: 1 }, tweenTime, Phaser.Easing.Sinusoidal.InOut);
        prizeIn.onStart.addOnce(() => { // At the same time...
            game.add.tween(claimDisplay.banner.scale) // The banner squeezes in
                .to({ x: 1, y: 1 }, tweenTime, Phaser.Easing.Sinusoidal.InOut, true);
            game.add.tween(claimDisplay.banner) // The banner fades in
                .to({ alpha: 1 }, tweenTime, Phaser.Easing.Sinusoidal.InOut, true);

            game.add.tween(claimDisplay.chestClosed) // The closed chest hops in
                .to({ y: [chestY - 150, chestY] }, tweenTime, Phaser.Easing.Sinusoidal.InOut, true);
            const claimChest = game.add.tween(claimDisplay.chestClosed.scale) // The closed chest grows from tiny to big
                .to({ x: claimDisplay.chestOpen.scale.x, y: claimDisplay.chestOpen.scale.y }, tweenTime, Phaser.Easing.Sinusoidal.Out, true);

            claimChest.onComplete.addOnce(() => { // Once the chest hops in,
                const shakeTween1 = game.add.tween(claimDisplay.chestClosed) // It'll shake twice
                    .to({ angle: [10, -10, 0] }, 250, Phaser.Easing.Sinusoidal.InOut, true, tweenTime);
                const shakeTween2 = game.add.tween(claimDisplay.chestClosed) // copy of shake one but I need a longer delay here
                    .to({ angle: [10, -10, 0] }, 250, Phaser.Easing.Sinusoidal.InOut, false, tweenTime * 1.5);
                shakeTween1.chain(shakeTween2);
                shakeTween2.onComplete.addOnce(() => { // Once its done shaking...
                    game.time.events.add(tweenTime * 2, () => { // The suspense is killing me!
                        game.add.tween(claimDisplay.shine) // The shine tweens in
                            .to({ alpha: 1 }, tweenTime / 2, Phaser.Easing.Sinusoidal.InOut, true);
                        game.add.tween(claimDisplay.chestOpen) // The opened chest tweens in (making it look like it opened)
                            .to({ alpha: 1 }, tweenTime / 2, Phaser.Easing.Sinusoidal.InOut, true);
                        game.add.tween(claimDisplay.chestClosed) // The closed chest tweens out
                            .to({ alpha: 0 }, tweenTime / 2, Phaser.Easing.Sinusoidal.InOut, true);
                        game.time.events.add(tweenTime * 1.5, () => { // Then a delay...
                            const prizeOut = game.add.tween(claimDisplay.prizeDisplay) // The prize drops out
                                .to({ alpha: 1, y: prizeY }, tweenTime, Phaser.Easing.Sinusoidal.InOut);
                            const avatarOut = game.add.tween(claimDisplay.friend.avatar) // The avatar drops out too!
                                .to({ alpha: 1, y: friendY }, tweenTime, Phaser.Easing.Sinusoidal.InOut);
                            const bubbleOut = game.add.tween(claimDisplay.friend.bubble) // The bubble pops out too!
                                .to({ alpha: 1, y: bubbleY }, tweenTime, Phaser.Easing.Sinusoidal.InOut);
                            const jumpHeight = friendY - 15;
                            const avatarShake = game.add.tween(claimDisplay.friend.avatar) // The avatar hops
                                .to({ y: jumpHeight }, tweenTime / 2, Phaser.Easing.Sinusoidal.InOut, false, 0, 1, true);
                            prizeOut.chain(avatarOut);
                            avatarOut.chain(bubbleOut);
                            bubbleOut.chain(avatarShake);
                            bubbleOut.onComplete.addOnce(() => { // When done, it applies the gifts
                                claimDisplay.applyGifts();
                                game.time.events.add(2000, () => { // Wait some more...
                                    this.outroSequence(); // Outro (as another function)
                                }, this);
                            }, this);
                            prizeOut.start();
                        });
                    });
                });
            });
        });

        cardOut.start();
        prizeIn.start();
    }

    /**
     * Outro is not with the big tween to keep it separate
     */
    outroSequence() {
        const tweenTime = 500;

        const outroTween = game.add.tween(this.claimElements.container) // Tweens the container to disappear
            .to({ alpha: 0 }, tweenTime, Phaser.Easing.Sinusoidal.InOut);
        outroTween.onComplete.addOnce(() => { // When its done
            this.claimElements.shine.update = () => {}; // Destroy the claim elements
            this.claimElements.container.destroy();
            if (this.claimElements.container.parent) {
                this.claimElements.container.parent.removeChild(this.claimElements.container);
            }
            this.claimElements = null;
            this.card.destroyCard(); // Destroy the card

            if (OMT.feature.getFeatureFriendshipChest()) {
                G.sb('pushWindow').dispatch('friendshipChestPromo'); // Open the promo card
            } else {
                G.saveState.friendshipChestDataManager.triggerPromoInitial(); // Trigger it even though it actually never shows. The steps to appear will make it show
            }
            this.closeWindow(); // Close this...
        });
        outroTween.start();
    }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.friendshipChestFTUAward = Window_friendshipChestFTUAward;